import './CountrySelector.scss';

import { Avatar, Segmented } from 'antd';
import { useContext, useEffect } from 'react';

import { ColorModeContext, type ThemeVariant } from '@/contexts/ColorModeContext';
import { useCountryContext } from '@/contexts/CountryContext';
import es_flag from '@/img/es.svg';
import pt_flag from '@/img/pt.svg';

/**
 * Flag de api only_br:
 * - false: muestra datos de todos los países menos Brasil.
 * - true: muestra solo datos de Brasil.
 */
const ARGENTINA_COUNTRY_ID = 0;
const BRASIL_COUNTRY_ID = 1;
const BRASIL_DATABASE_COUNTRY_ID = 3;
const getThemeVariantByCountryId = (countryId?: number): ThemeVariant =>
  countryId === BRASIL_COUNTRY_ID || countryId === BRASIL_DATABASE_COUNTRY_ID
    ? 'brasil'
    : 'default';
const CountrySelector = () => {
  const { selectedCountryId, setSelectedCountryId } = useCountryContext();
  const { setThemeVariant, themeVariant } = useContext(ColorModeContext);
  const selectedThemeVariant = getThemeVariantByCountryId(selectedCountryId);
  const selectedSegmentedCountryId =
    selectedThemeVariant === 'brasil' ? BRASIL_COUNTRY_ID : ARGENTINA_COUNTRY_ID;

  useEffect(() => {
    if (themeVariant === 'hidden' || themeVariant === selectedThemeVariant) {
      return;
    }

    // @metadata CountryThemeSync
    // Sincroniza la variante visual con el país activo sin exponer un segundo selector.
    setThemeVariant(selectedThemeVariant);
  }, [selectedThemeVariant, setThemeVariant, themeVariant]);

  const handleChangeCountry = (countryId: number | string) => {
    const nextCountryId = Number(countryId);

    setSelectedCountryId(nextCountryId);
    setThemeVariant(getThemeVariantByCountryId(nextCountryId));
  };

  return (
    <Segmented
      className="CountrySelector"
      value={selectedSegmentedCountryId}
      onChange={handleChangeCountry}
      options={[
        {
          className: 'CountrySelectorOption',
          icon: <Avatar size={16} src={es_flag} />,
          label: 'AR',
          value: ARGENTINA_COUNTRY_ID,
        },
        {
          className: 'CountrySelectorOption',
          icon: <Avatar size={16} src={pt_flag} />,
          label: 'BR',
          value: BRASIL_COUNTRY_ID,
        },
      ]}
      size="small"
    />
  );
};

export default CountrySelector;
